module.exports = __webpack_public_path__ + "img/faming15.47bee6cd.png";